import { Base64 } from 'js-base64'
import CryptoJS from '@ms/fetch/lib/CryptoJS'
import RSAKey from '@ms/fetch/lib/RSAKey'

// 公钥的modulus，公钥的 e即 exponent 是10001
const publicKeyModulus =
  'ac3233fe0efc66e8bbab082817eda4402d0199ee9d4d1c3ef0a7c51c6be8fcb080cf5331b6b4dcbc1fc98e21fdc1abd59538a09053b6840db453f03b27fa4dd9c7587d191a800ea2a456e7abe05b4fd1ba02fced10c4e58792f5bddf782b76b1744a51ab2ff8e4bac7e9fd42a0d7fa311f4d01c15250a1ccb1c73d5201bca803'

const exponent = '10001'

function hexToBase64(str) {
  return Base64.btoa(
    String.fromCharCode.apply(
      null,
      str
        .replace(/\r|\n/g, '')
        .replace(/([\da-fA-F]{2}) ?/g, '0x$1 ')
        .replace(/ +$/, '')
        .split(' ')
    )
  )
}
// 创建rsa对象
const rsa = new RSAKey()
rsa.setPublic(publicKeyModulus, exponent)

export {
  // aes加密对象导出
  CryptoJS,
  // hex到base64
  hexToBase64,
  // 已经创建好的rsa解密对象
  rsa
}
